import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/global/header/header'
import Footer from '../components/global/footer/footer'
import './../styles/base/base.scss'

const Layout = ({ children, data }) => (
  <div>
  <Helmet
  title={data.site.siteMetadata.title}
  meta={[
    { name: 'description', content: "Curveball is your daily fix for sports trivia and news. Delivered to your phone, every day." },
    { name: 'keywords', content: "nba, nfl, mlb, mls, basketball, football, baseball, soccer, highlights, trivia, quiz, friends, viral" },
    { name: 'theme-color', content: "#331661"},
    { name: 'twitter:site', content: "Curveball.tv" },
    { name: 'twitter:title', content: "Curveball.tv" },
    { name: 'twitter:creator', content: "Curveball.tv" },
    { name: 'twitter:title', content: "" },
    { name: 'twitter:image', content: "" },
    { property: 'og:title', content: "Curveball.tv" },
    { property: 'og:site_name', content: "Curveball.tv" },
    { property: 'og:type', content: "website" },
    { property: 'og:url', content: "https://curveball.tv" },
    { property: 'og:description', content: "Get your daily sports digest while competing in trivia for real cash prizes!" },
    { property: 'og:image', content: ""},
    { property: 'og:site_name', content: "Curveball.tv" },
    ]}
    >
    <html lang="en" />
    </Helmet>
    <div className="page-container">
    <Header siteTitle={data.site.siteMetadata.title} />
    <div className="content-wrapper">
    {children()}
    </div>
    <Footer />
    </div>
    </div>
    )

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
query SiteTitleQuery {
  site {
    siteMetadata {
      title
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/layouts/index.js